import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { ClientViewModel } from '../../models-views/client.view.model';
import { NzModalService } from 'ng-zorro-antd/modal';
import { AppCommon } from '../../providers/app-common';

@Component({
  selector: 'app-client-poc-detail',
  standalone: false,
  templateUrl: './client-poc-detail.component.html',
  styleUrl: './client-poc-detail.component.scss'
})
export class ClientPocDetailComponent implements OnChanges {
  @Input() poc_details: any[] = [];
  @Input() showActions: boolean = true;
  @Input() isVisible: boolean = false;
  @Output() closePoc: EventEmitter<Boolean> = new EventEmitter<Boolean>()
  @Output() editPocEvent: EventEmitter<any> = new EventEmitter<any>() 
  @Output() pocDeletedEvent: EventEmitter<Boolean> = new EventEmitter<Boolean>()
  loggedInUser: any

  constructor(private vmc: ClientViewModel, private modal: NzModalService) {
    this.loggedInUser = AppCommon.getloggedInObject().user
 
  }

  ngOnInit(): void {
    this.vmc.parentClientPocDetailComponent = this
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log('Data received from parent component:', { 
    //   poc_details: this.poc_details,
    //   showActions: this.showActions,
    //   isVisible: this.isVisible
    // });
    if (changes['poc_details']) {
      // console.log('poc_details updated:', this.poc_details);
    }
  }

  truncateText(text: string | null | undefined, maxLength: number = 5): string {
    if (!text) {
      return '';
    }
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + '...';
    }
    return text;
  }


  deletePOC(poc: any) {
    this.vmc.deletePOC(poc.id);
  }

  pocDeleted(deleteId: number) {
    this.poc_details = this.poc_details.filter(el => el.id !== deleteId);
    if(this.poc_details.length === 0){
      this.isVisible = false;
      this.closePoc.emit(true);
    } else {
      this.pocDeletedEvent.emit(true);
    }
  }

  handleOk(): void {
    this.isVisible = false;
    this.closePoc.emit(false)
  }

  handleCancel(): void {
    this.isVisible = false;
    this.closePoc.emit(false)
  }

  editPOC(poc: any) {
    this.editPocEvent.next(poc);
  }

  pocUpdated(){
    this.closePoc.emit(true)
  }

  setPrimaryPOCDetail(event: any, poc: any){
    this.modal.confirm({
      nzTitle: 'Are you sure you want to make primary"' + poc.poc_name + '"?',
      nzContent: '<b style="color: red;">If you make this, you will no longer be able restore it.</b>',
      nzOkText: 'Yes',
      nzOkType: 'primary',
      nzOkDanger: true,
      nzOnOk: () => this.vmc.updatePOC(
        {
          id: poc.id,
          type: 1,
          modified_by: this.loggedInUser.id
        },
        poc.id,
        'add-poc-detail'
      ),
      nzCancelText: 'No',
      nzOnCancel: () => this.closePoc.emit(true)
    });
  }
}
